import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

export const Description = styled.p`
  font: ${brandFont.headerThree};
  text-transform: uppercase;
  margin-top: 0;
  text-align: center;
  text-shadow: 0px 3px 7px rgb(80, 35, 20);
  ${Styles.desktop`
    text-align: left;
    font: ${brandFont.headerOne};
  `}
`;
